<div class="modal-header">
  <h4 class="modal-title cs-modal-title">{{isInCreateMode ? "CREATE TEAMS" :"EDIT TEAMS"}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body game-modal" [ngClass]="{'has-delete-btn' : teams.length > 2}">
  <div>
    <label class="font-weight-500">Teams:</label>
  </div>
  <div class="tabs-wrap">
    <ul class="nav nav-tabs team-tabs mb-3">
      <li class="nav-item" *ngFor="let team of teams; let i = index">
        <a class="nav-link" [ngClass]="{'active' : i === currentActiveTabIndex}"
          (click)="changeTeam(i)" title="{{team.name}}">{{team.name}}</a>
      </li>
      <li class="nav-item" *ngIf="teams.length < 9">
        <button class="add-btn" (click)="addTeam()" title="Add team">+</button>
      </li>
    </ul>
    <div class="form-group row">
      <label class="col-auto col-form-label">Name:</label>
      <div class="col-auto">
        <input type="text" class="form-control" (blur)="updateTeamName($event)" [value]="teams[currentActiveTabIndex].name">
      </div>
    </div>
  </div>

  <div class="form-group">
    <!--<span class="selected-count pull-right">{{dc.getSelectedUsersCountOfCurrentTeam()}} student(s)</span>-->
    <label class="font-weight-500">Students:</label>
    <div class="students-listing mb-3">
      <div class="listing-top-filter">
        <span class="mr-3">Show:</span>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" class="custom-control-input" name="optionsRadios" id="all_students" value="all"
                 [(ngModel)]="userShowMode"
                 (click)="changeShowMode('all')"
                 checked>
          <label for="all_students" class="custom-control-label">All</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" class="custom-control-input" name="optionsRadios" id="selected_students" value="selected"
                 [(ngModel)]="userShowMode"
                 (click)="changeShowMode('selected')">
          <label for="selected_students" class="custom-control-label">This team</label>
        </div>
      </div>
      <div class="students-list">
        <span class="no-data-txt" *ngIf="(usersList | availableStudentsForTeam:userShowMode:currentTeamId) === 0">No students</span>

        <div class="student-item" *ngFor="let user of filteredUsersList ">
          <div class="custom-control custom-checkbox d-flex align-items-center"
               [ngClass]="{'disabled': user.teamId !== -1 && user.teamId !== currentTeamId}">
            <input type="checkbox" id="user_{{user.id}}" class="custom-control-input"
                   (click)="selectUser(user)"
                   [checked]="user.teamId !== -1" value=""/>
            <label for="user_{{user.id}}" class="custom-control-label">{{user.displayName}}</label>
            <span class="team-name ml-auto" *ngIf="user.teamId !== -1">{{teams | teamName:user.teamId}}</span>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-sm red-btn" (click)="removeCurrentTeam()" *ngIf="teams.length > 2">
      <i class="far fa-trash-alt mr-2"></i>Delete team
    </button>
  </div>
</div>


<div class="modal-footer d-flex">
  <button (click)="onCancel()"
          type="button" class="btn btn-secondary">Cancel</button>
  <button (click)="onSubmit()"
          type="submit" class="btn btn-primary ml-auto">{{isInCreateMode ? "Create" :"Save"}}</button>
</div>
